//REGISTER
export const POST_REGISTER = "/register";
export const GET_VERIFY_EMAIL = (token) => `/verify-email/${token}`;

//LOGIN
export const LOGIN = "/auth";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";

//EVENT
export const POST_VIEW_EVENT_SONGS = (id) => `/guest/event_song/${id}`;
// Ta sama lista, ale dla zalogowanego prowadzącego — tylko tędy wracają cudze
// dedykacje i notatki gości.
export const POST_VIEW_EVENT_SONGS_HOST = (id) => `/event_song/${id}/host`;
export const POST_ADD_EVENT_SONG_ADMIN = "/event_song";
export const GET_VIEW_EVENT_DETAILS = (id) => `/guest/events/${id}`;
export const POST_ADD_EVENT_SONG_GUEST = "/guest/event_song";
export const DELETE_EVENT_SONG_ADMIN = (id) => `/event_song/${id}`;
export const DELETE_EVENT_SONG_GUEST = (id) => `/guest/event_song/${id}/delete`;
export const POST_EVENT_SONG_NOTE_GUEST = (id) => `/guest/event_song/${id}/note`;
export const POST_EVENT_SONG_EDIT_GUEST = (id) => `/guest/event_song/${id}/song`;
export const POST_DEDICATION_GUEST = "/guest/dedications";
export const POST_DELETE_DEDICATION_GUEST = (id) => `/guest/dedications/${id}/delete`;
export const DELETE_DEDICATION_ADMIN = (id) => `/dedications/${id}`;
export const PATCH_EVENT_UPDATE = (id) => `/events/${id}`;
export const PATCH_EVENT_START = (id) => `/events/${id}/start`;
export const PATCH_EVENT_END = (id) => `/events/${id}/end`;
export const GET_VIEW_EVENT_USERS_LIST = (id) => `/events/${id}/users`;
export const POST_EVENT_LOGO_UPLOAD = (id) => `/events/${id}/logo`;

//SONG
export const GET_VIEW_SONGS_LIST = "/guest/songs";
export const GET_SONGS_LIBRARY = "/songs";
export const UPDATE_SONG = (id) => `/songs/${id}`;
export const DELETE_SONG = (id) => `/songs/${id}`;

//SONG LIBRARY
export const GET_SONG_LIBRARIES = "/song_libraries";
export const GET_SONG_LIBRARY = (id) => `/song_libraries/${id}`;
export const POST_SONG_LIBRARY = "/song_libraries";
export const PATCH_SONG_LIBRARY = (id) => `/song_libraries/${id}`;
export const DELETE_SONG_LIBRARY = (id) => `/song_libraries/${id}`;
export const POST_SONG_LIBRARY_IMPORT_CSV = (id) => `/song_libraries/${id}/import-csv`;

//SONG LIBRARY SONG
export const GET_LIBRARY_SONGS = (libraryId) => `/song_libraries/${libraryId}/songs`;
export const POST_LIBRARY_SONG = "/song_library_songs";
export const POST_BULK_LIBRARY_SONGS = "/song_libraries/bulk-add-songs";
export const DELETE_LIBRARY_SONG = (id) => `/song_library_songs/${id}`;

//USER
export const POST_ADD_USER = "/users";
export const POST_LOGIN_GUEST = "/guest/users";
export const GET_USER_LIST = "/users";
export const DELETE_USER = (id) => `/users/${id}`;
export const GET_USER_DETAILS = (id) => `/users/${id}`;
export const POST_REGENERATE_USER_QR = (userId) => `/users/${userId}/qr-code`;
export const POST_SET_USER_ENABLED = (userId) => `/users/${userId}/enabled`;

//TIPS
export const GET_USER_TIPS = (userId) => `/users/${userId}/tips`;
export const POST_MARK_USER_TIPS_PAID = (userId) => `/users/${userId}/tips/mark-paid`;
export const PATCH_TIP = (id) => `/tips/${id}`;

// MESSAGE
export const POST_ADD_MESSAGE = "/guest/messages";
